import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import AdminLayout from '../../components/AdminLayout';

const s = {
  h1: { fontFamily:"'Inter', sans-serif", fontSize:34, fontWeight:700, color:'var(--text)', marginBottom:4 },
  h1em: { fontStyle:'italic', color:'var(--accent)' },
  sub: { fontSize:13, color:'var(--text-2)', marginBottom:24 },
  topRow: { display:'flex', gap:12, alignItems:'center', marginBottom:20 },
  searchWrap: { position:'relative', flex:1, maxWidth:360 },
  searchIcon: { position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--text-2)', pointerEvents:'none' },
  searchInput: { width:'100%', padding:'10px 12px 10px 36px', border:'1.5px solid var(--divider)', borderRadius:'var(--r-input)', fontSize:13, color:'var(--text)', background:'var(--surface)', outline:'none', boxSizing:'border-box' },
  addBtn: { padding:'10px 20px', background:'var(--accent)', color:'var(--btn-text)', border:'none', borderRadius:'var(--r-btn)', fontSize:12, fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase', cursor:'pointer', whiteSpace:'nowrap' },
  alunaSection: { marginBottom:32 },
  alunaHeader: { display:'flex', alignItems:'center', gap:10, marginBottom:12, paddingBottom:8, borderBottom:'1px solid var(--divider)' },
  alunaAvatar: { width:32, height:32, borderRadius:'50%', background:'var(--text)', border:'1.5px solid var(--accent)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Inter',sans-serif", fontSize:13, fontWeight:700, color:'#FAF7F2', flexShrink:0 },
  alunaName: { fontSize:14, fontWeight:600, color:'var(--text)' },
  treinoCard: { background:'var(--surface)', border:'1px solid var(--divider)', borderRadius:'var(--r-btn)', padding:'16px 20px', marginBottom:6, display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, boxShadow:'var(--sh-card)' },
  treinoInfo: { flex:1, minWidth:0 },
  treinoTitulo: { fontSize:14, fontWeight:600, color:'var(--text)', marginBottom:2 },
  treinoMeta: { fontSize:11, color:'var(--text-2)', display:'flex', gap:12, flexWrap:'wrap' },
  metaChip: { background:'var(--bg)', padding:'2px 8px', borderRadius:'100px', fontSize:11 },
  actions: { display:'flex', gap:6, flexShrink:0 },
  btnEdit: { padding:'6px 12px', border:'1px solid var(--divider)', borderRadius:'var(--r-btn)', background:'transparent', fontSize:11, color:'var(--text-3)', cursor:'pointer', fontWeight:500 },
  btnDel: { padding:'6px 12px', border:'1px solid rgba(229,57,53,0.2)', borderRadius:'var(--r-btn)', background:'rgba(229,57,53,0.04)', fontSize:11, color:'#E53935', cursor:'pointer', fontWeight:500 },
  empty: { padding:'48px 32px', textAlign:'center', background:'var(--surface)', border:'1px solid var(--divider)', borderRadius:'var(--r-card)', color:'var(--text-2)', fontSize:13, boxShadow:'var(--sh-card)' },
  confirmOverlay: { position:'fixed', inset:0, background:'rgba(37,28,25,0.65)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 },
  confirmCard: { background:'var(--bg)', padding:32, borderRadius:'var(--r-card)', maxWidth:360, width:'100%', textAlign:'center' },
  confirmTitle: { fontSize:16, fontWeight:700, color:'var(--text)', marginBottom:8 },
  confirmText: { fontSize:13, color:'var(--text-2)', marginBottom:24 },
  confirmActions: { display:'flex', gap:10 },
  btnDanger: { flex:1, padding:12, background:'#E53935', color:'#fff', border:'none', borderRadius:'var(--r-btn)', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnCancel: { flex:1, padding:12, background:'transparent', border:'1px solid var(--divider)', color:'var(--text-2)', borderRadius:'var(--r-btn)', fontSize:13, cursor:'pointer' },
};

export default function Treinos() {
  const { alunas } = useAuth();
  const { treinos, deletarTreino } = useData();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const alunaIdSelecionada = searchParams.get('aluna') || '';
  const alunaSelecionada = (alunas || []).find(a => a.id === alunaIdSelecionada);
  const [busca, setBusca] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  const alunasFiltradas = (alunas || []).filter(a => {
    if (alunaIdSelecionada && a.id !== alunaIdSelecionada) return false;
    const treinosDaAluna = treinos.filter(t => t.aluna_id === a.id || t.alunaId === a.id);
    if (treinosDaAluna.length === 0) return false;
    if (!busca) return true;
    return a.name.toLowerCase().includes(busca.toLowerCase()) ||
      treinosDaAluna.some(t => t.titulo?.toLowerCase().includes(busca.toLowerCase()));
  });

  function getTreinos(alunaId) {
    return treinos.filter(t => t.aluna_id === alunaId || t.alunaId === alunaId)
      .sort((a, b) => (a.semana || 1) - (b.semana || 1));
  }

  async function handleDelete() {
    if (!confirmDelete) return;
    await deletarTreino(confirmDelete.id);
    setConfirmDelete(null);
  }

  const totalTreinos = treinos.length;

  return (
    <AdminLayout>
      <div>
        <h1 style={s.h1}>{alunaSelecionada ? 'Treinos de ' : 'Treinos '}<em style={s.h1em}>{alunaSelecionada ? alunaSelecionada.name : '& Fichas'}</em></h1>
        <p style={s.sub}>{alunaSelecionada ? `${getTreinos(alunaSelecionada.id).length} ficha${getTreinos(alunaSelecionada.id).length !== 1 ? 's' : ''} cadastrada${getTreinos(alunaSelecionada.id).length !== 1 ? 's' : ''} para esta aluna` : `${totalTreinos} treino${totalTreinos !== 1 ? 's' : ''} cadastrado${totalTreinos !== 1 ? 's' : ''}`}</p>

        {alunaSelecionada && (
          <button type="button" onClick={() => setSearchParams({})} style={{ ...s.btnEdit, marginBottom:16, padding:'8px 14px' }}>← Ver treinos de todas as alunas</button>
        )}

        <div style={s.topRow}>
          <div style={s.searchWrap}>
            <span style={s.searchIcon}>🔍</span>
            <input
              style={s.searchInput}
              placeholder="Buscar por aluna ou treino..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
            />
          </div>
          <button style={s.addBtn} onClick={() => navigate(alunaSelecionada ? `/admin/treino/novo?aluna=${alunaSelecionada.id}` : '/admin/treino/novo')}>
            + {alunaSelecionada ? 'Novo treino para esta aluna' : 'Novo treino'}
          </button>
        </div>

        {alunasFiltradas.length === 0 ? (
          <div style={s.empty}>
            {busca ? `Nenhum treino encontrado para "${busca}"` : alunaSelecionada ? 'Esta aluna ainda não possui treino cadastrado.' : 'Nenhum treino cadastrado ainda.'}
            {alunaSelecionada && !busca && (
              <div><button style={{ ...s.addBtn, marginTop:16 }} onClick={() => navigate(`/admin/treino/novo?aluna=${alunaSelecionada.id}`)}>+ Cadastrar primeiro treino</button></div>
            )}
          </div>
        ) : alunasFiltradas.map(aluna => (
          <div key={aluna.id} style={s.alunaSection}>
            <div style={s.alunaHeader}>
              <div style={s.alunaAvatar}>{aluna.name?.[0]?.toUpperCase()}</div>
              <span style={s.alunaName}>{aluna.name}</span>
              <span style={{ fontSize:11, color:'#8C7F70' }}>
                {getTreinos(aluna.id).length} treino{getTreinos(aluna.id).length !== 1 ? 's' : ''}
              </span>
            </div>
            {getTreinos(aluna.id).map(treino => (
              <div key={treino.id} style={s.treinoCard}
                onMouseEnter={e => e.currentTarget.style.borderColor = '#5B402E'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(37,28,25,0.08)'}
              >
                <div style={s.treinoInfo}>
                  <div style={s.treinoTitulo}>{treino.titulo || 'Sem título'}</div>
                  <div style={s.treinoMeta}>
                    {treino.semana && <span style={s.metaChip}>Semana {treino.semana}</span>}
                    {treino.descricao && <span style={s.metaChip}>{treino.descricao}</span>}
                    {treino.exercicios && <span style={s.metaChip}>{treino.exercicios.length} exercício{treino.exercicios.length !== 1 ? 's' : ''}</span>}
                    {treino.objetivo && <span style={s.metaChip}>{treino.objetivo}</span>}
                  </div>
                </div>
                <div style={s.actions}>
                  <button style={{ ...s.btnEdit, background:'#6B4FA8', color:'#fff', borderColor:'#6B4FA8' }} onClick={() => navigate(`/admin/preview/aluna/${aluna.id}/treino/${treino.id}`)}>
                    👁 Ver como aluna
                  </button>
                  <button style={s.btnEdit} onClick={() => navigate(`/admin/treino/${treino.id}`)}>
                    ✏️ Editar
                  </button>
                  <button style={s.btnDel} onClick={() => setConfirmDelete(treino)}>
                    🗑 Excluir
                  </button>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      {confirmDelete && (
        <div style={s.confirmOverlay}>
          <div style={s.confirmCard}>
            <div style={{ fontSize:32, marginBottom:12 }}>🗑️</div>
            <div style={s.confirmTitle}>Excluir treino?</div>
            <div style={s.confirmText}>
              "{confirmDelete.titulo}" será removido permanentemente. Essa ação não pode ser desfeita.
            </div>
            <div style={s.confirmActions}>
              <button style={s.btnCancel} onClick={() => setConfirmDelete(null)}>Cancelar</button>
              <button style={s.btnDanger} onClick={handleDelete}>Excluir</button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
